import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect, useMemo } from "react";

import Home from "./Home";

import * as anchor from "@malloc-protocol/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { getConstants } from "./config/constants";
import ErrorSnackbar from "./components/error-snackbar";
import { inferContextFromConstruction } from "./components/graph-visualizer";
import { globalStore } from "./globalStore";
import { useStore } from "react-stores";

const network = getConstants().solana.NETWORK;

const rpcHost = getConstants().solana.RPC;
const connection = new anchor.web3.Connection(rpcHost);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const state = useStore(globalStore);
  const endpoint = useMemo(() => clusterApiUrl("mainnet-beta"), []);

  const wallets = useMemo(
    () => [getPhantomWallet(), getSolflareWallet(), getSolletWallet()],
    []
  );

  useEffect(() => {
    inferContextFromConstruction(state);
  }, []);

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletDialogProvider>
          <Home connection={connection} txTimeout={txTimeout} />
          <ErrorSnackbar />
        </WalletDialogProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};

export default App;
